import { render, staticRenderFns } from "./MedicalFile.vue?vue&type=template&id=793c0c97&scoped=true"
import script from "./MedicalFile.vue?vue&type=script&lang=js"
export * from "./MedicalFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793c0c97",
  null
  
)

export default component.exports